export default __webpack_public_path__ + "static/media/151-work-tools.cd90b74f.png";